/* global System */
// register component(s) with react habitat

export default {
  SprintRaceSpeakerBoxSmall: () =>
    System.import(
      /* webpackChunkName: "SprintRaceSpeakerBoxSmall" */
      './Component'
    ),
}
